import FormProvider from "@avinet/adaptive-ui-core/form/FormProvider";
import useForm from "@avinet/adaptive-ui-core/form/useForm";
import Survey from "../../types/Survey";
import PlainLayoutRenderer from "./plain/PlainLayoutRenderer";
import WizardLayoutRenderer from "./wizard/WizardLayoutRenderer";

export interface LayoutRendererProps {
  survey: Survey;
}

export type LayoutRenderer = (props: LayoutRendererProps) => JSX.Element;

interface FormRendererProps {
  survey: Survey;
  onSubmit?: (data: any) => void;
  onErrors?: (erros: any[]) => void;
}

const FormRenderer = ({ survey, onSubmit, onErrors }: FormRendererProps) => {
  const { form, state } = useForm<Survey>({
    onSubmit,
    onErrors,
  });
  let LayoutRenderer: LayoutRenderer;

  if (process.env.NODE_ENV === "development") {
    (window as any).formState = state;
  }

  switch (survey.layout) {
    case "plain":
      LayoutRenderer = PlainLayoutRenderer;
      break;

    case "wizard":
      LayoutRenderer = WizardLayoutRenderer;
      break;

    default:
      return <h1>Invalid layout</h1>;
  }

  return (
    <FormProvider form={form} state={state}>
      <LayoutRenderer survey={survey} />
    </FormProvider>
  );
};

export default FormRenderer;
